<template>
  <div class="calendar-container">
    <FullCalendar ref="fullCalendar" :options="calendarOptions" />
    <el-dialog :close-on-click-modal="false" :title="editingEvent ? 'Tapşırığı redaktə et' : 'Yeni tapşırıq'"
      modal-class="modal-class" width="35%" v-model="showEventModal">
      <div id="basic-info">
        <div class="card-body pt-0">
          <div class="row form-input">
            <div class="col-sm-12">
              <label class="form-label">Başlıq</label>
              <el-input v-model="eventForm.title" size="large" placeholder="Hadisə adı" />
            </div>
          </div>
          <div class="row form-input">
            <div class="col-sm-6">
              <label class="form-label">Tarix</label>
              <el-date-picker v-model="eventForm.startDate" type="date" style="width: 100%;" placeholder="Seçin"
                size="large" format="DD.MM.YYYY" />
            </div>
            <div class="col-sm-6">
              <label class="form-label">Vaxt</label>
              <el-time-picker v-model="eventForm.startTime" :default-value="defaultTime" format="HH:mm"
                placeholder="Seçin " style="width: 100%;" size="large" />
            </div>
          </div>
          <div class="row form-input">
            <div class="col-sm-12">
              <label class="form-label">Təsvir</label>
              <el-input v-model="eventForm.description" size="large" type="textarea" rows="3"
                placeholder="Ətraflı məlumat yazın" />
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-2">
          <soft-button type="button" color="success" @click="saveEvent">
            {{ editingEvent ? 'Qəbul et' : 'Daxil et' }}
          </soft-button>
          &nbsp;
          <soft-button type="button" color="secondary" @click="closeModal">İmtina</soft-button>
          &nbsp;
          <soft-button v-if="editingEvent" type="button" color="danger" @click="deleteEvent">Sil</soft-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import allLocales from '@fullcalendar/core/locales-all'
import { CreateCalendarEvent, GetCalendarEvents, UpdateCalendarEvent, DeleteCalendarEvent } from "@/project/Source/calendarevent.js"
import SoftButton from "@/components/SoftButton.vue"

export default {
  components: {
    FullCalendar,
    SoftButton
  },
  props: {
    subrogationId: { type: Number }
  },
  data() {
    return {
      defaultTime: new Date(2000, 0, 1, 0, 0, 0),
      calendarOptions: {
        contentHeight: "auto",
        aspectRatio: 1.8,
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        locales: allLocales,
        locale: 'az',
        firstDay: 0,
        editable: true,
        selectable: true,
        eventDrop: this.handleEventDrop,
        eventTimeFormat: { hour: '2-digit', minute: '2-digit', hour12: false },
        events: (info, successCallback) => {
          this.fetchEvents(info, successCallback)
        },
        select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        titleFormat: function (date) {
          const monthsAz = [
            'yanvar', 'fevral', 'mart', 'aprel', 'may', 'iyun',
            'iyul', 'avqust', 'sentyabr', 'oktyabr', 'noyabr', 'dekabr'
          ]
          const d = date.date.marker
          const month = monthsAz[d.getMonth()]
          const year = d.getFullYear()
          return month.charAt(0).toUpperCase() + month.slice(1) + ' ' + year
        },
        dayHeaderContent: function (arg) {
          const daysAz = ['B.e.', 'Ç.a.', 'Çər.', 'C.a.', 'Cümə', 'Şənbə', 'Bazar']
          return daysAz[arg.date.getDay()]
        },
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },
        buttonText: {
          today: 'Bugün',
          month: 'Ay',
          week: 'Həftə',
          day: 'Gün'
        },
        allDayText: 'Bütün gün'
      },
      showEventModal: false,
      editingEvent: false,
      currentEventId: null,
      eventForm: {
        title: '',
        startDate: '',
        startTime: null,
        description: '',
        subrogationId: null
      },
      selectInfo: null
    }
  },
  methods: {
    forceCalendarResize() {
      this.$nextTick(() => {
        setTimeout(() => {
          const calendarApi = this.$refs.fullCalendar?.getApi()
          if (calendarApi) calendarApi.updateSize()
        }, 0)
      })
    },
    async fetchEvents(info, successCallback) {
      try {
        const fromDate = new Date(info.startStr).toISOString().split('T')[0];
        const toDate = new Date(info.endStr).toISOString().split('T')[0];
        const params = {
          userId: this.$store.state.user.id,
          fromDate,
          toDate,
          subrogationId: this.subrogationId
        };
        const res = await GetCalendarEvents(params);
        const events = (res.data.data || []).map(e => ({
          id: e.id,
          title: e.title.length > 20 ? e.title.substring(0, 20) + '...' : e.title,
          start: e.startDate,
          end: e.startDate,
          allDay: e.allDay,
          description: e.description || '',
          fullTitle: e.title,
          subrogationId: e.subrogationId
        }));
        successCallback(events);
      } catch {
        successCallback([]);
      }
    },
    handleDateSelect(selectInfo) {
      const start = selectInfo.start
      this.eventForm = {
        title: '',
        startDate: new Date(start.getFullYear(), start.getMonth(), start.getDate()),
        startTime: new Date(2000, 0, 1, start.getHours(), start.getMinutes(), 0),
        description: '',
        subrogationId: this.subrogationId
      }
      this.showEventModal = true
      this.editingEvent = false
      this.selectInfo = selectInfo
    },
    handleEventClick(clickInfo) {
      const event = clickInfo.event
      this.currentEventId = event.id
      const eventStart = event.start
      const eventDate = new Date(eventStart.getFullYear(), eventStart.getMonth(), eventStart.getDate())
      this.eventForm = {
        title: event.extendedProps.fullTitle || event.title,
        startDate: eventDate,
        startTime: new Date(eventStart),
        description: event.extendedProps.description || '',
        subrogationId: event.extendedProps.subrogationId ?? this.subrogationId
      }
      this.editingEvent = true
      this.showEventModal = true
    },
    async handleEventDrop(info) {
      const event = info.event
      const userId = this.$store.state.user.id
      const newStart = event.start
      const timezoneOffset = newStart.getTimezoneOffset() * 60000
      const localISOTime = new Date(newStart.getTime() - timezoneOffset).toISOString()
      const updatePayload = {
        id: event.id,
        title: event.title,
        description: event.extendedProps.description || '',
        startDate: localISOTime,
        endDate: null,
        allDay: event.allDay,
        userId,
        commandUserId: userId,
        requestCorrelationId: crypto.randomUUID(),
        subrogationId: event.extendedProps.subrogationId ?? this.subrogationId
      }
      try {
        await UpdateCalendarEvent(updatePayload)
        this.$message.success('Uğurlu əməliyyat!')
      } catch (e) {
        this.$message.error('Yenilənmə zamanı xəta baş verdi.')
        info.revert()
      }
    },
    async saveEvent() {
      if (!this.eventForm.title.trim() || !this.eventForm.startDate || !this.eventForm.startTime) {
        this.$message.warning('Zəhmət olmasa bütün tələb olunan sahələri doldurun.')
        return
      }
      const userId = this.$store.state.user.id
      const selectedDate = new Date(this.eventForm.startDate)
      const selectedTime = new Date(this.eventForm.startTime)
      const fullDateTime = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        selectedTime.getHours(),
        selectedTime.getMinutes()
      )
      const timezoneOffset = fullDateTime.getTimezoneOffset() * 60000
      const localISOTime = new Date(fullDateTime.getTime() - timezoneOffset).toISOString()
      try {
        if (this.editingEvent) {
          const updatePayload = {
            id: this.currentEventId,
            title: this.eventForm.title,
            description: this.eventForm.description,
            startDate: localISOTime,
            endDate: null,
            allDay: false,
            userId,
            commandUserId: userId,
            requestCorrelationId: crypto.randomUUID(),
            subrogationId: this.subrogationId
          }
          await UpdateCalendarEvent(updatePayload)
        } else {
          const createPayload = {
            title: this.eventForm.title,
            description: this.eventForm.description,
            startDate: localISOTime,
            endDate: null,
            allDay: false,
            userId,
            requestCorrelationId: crypto.randomUUID(),
            subrogationId: this.subrogationId
          }
          await CreateCalendarEvent(createPayload)
        }
        this.$refs.fullCalendar.getApi().refetchEvents()
        this.$message.success('Uğurlu əməliyyat!')
      } catch (e) {
        this.$message.error('Xəta baş verdi!')
      }
      this.closeModal()
    },
    async deleteEvent() {
      const uid = this.$store.state.user.id
      try {
        await DeleteCalendarEvent(this.currentEventId, uid)
        this.$refs.fullCalendar.getApi().refetchEvents()
        this.$message.success('Uğurlu əməliyyat!')
      } catch (e) {
        this.$message.error('Xəta baş verdi!')
      }
      this.closeModal()
    },
    closeModal() {
      this.showEventModal = false
      this.editingEvent = false
      this.currentEventId = null
      this.resetForm()
      if (this.selectInfo) {
        this.selectInfo.view.calendar.unselect()
        this.selectInfo = null
      }
    },
    resetForm() {
      this.eventForm = {
        title: '',
        startDate: '',
        startTime: null,
        description: '',
        subrogationId: this.subrogationId
      }
    }
  }
}
</script>

<style>
.calendar-container {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
  position: relative;
}

.fc {
  font-family: Arial, sans-serif;
}

.fc-toolbar-title {
  font-weight: bold;
  color: #2c3e50;
}

.fc-event {
  cursor: pointer;
  border-radius: 4px;
  font-size: 0.85em;
  padding: 2px 4px;
}

.fc-day-today {
  background-color: #fff8e1 !important;
}

.form-input {
  margin-bottom: 1rem;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.fc-event,
.fc-timegrid-event,
.fc-daygrid-event {
  max-width: 90% !important;
  margin-right: 10px;
  box-sizing: border-box;
}
</style>
